const { log } = require('app-lib-log');
const { ERROR_CODE, AppError } = require('./app-lib-error');
const { getRootPath, resolve } = require('app-lib-node');
const { autoRequire } = require("app-lib-nobuild");

const prase = require('./prase');
// 解析统一测脚本参数
const praseOpt = (opt) => {
    let { options } = opt;
    // 倒数第二个为配置参数
    let option = options.slice(options.length - 2, options.length - 1)[0];
    // 入参为前面内容
    let arg = options.slice(0, options.length - 2);
    return { arg, option };
}


/**
 *  执行 参数传递 同事执行对应的start函数
 * @param {*} args 
 * @param  {...any} options 
 */
const action = async (args, ...options) => {
    let { commond, start, ...arg } = args;
    let outOption = options.slice(0, options.length - 1);
    const commondName = typeof options[0] === 'string' ? options[0] : '';

    log.md(`${commond} ${commondName}::BEGAIN`, { ...arg, options: outOption })

    // 构建
    let error = await start({ commond, ...arg, options });
    // 校验
    if (error === void 0) {
        return new AppError(`[./plugins/${commond}.commong.js] function need return `, ERROR_CODE.ERROR)
    }
    // 数字返回 则表示直接是ERROR_CODE的异常
    if (typeof error != 'object') {
        error = new AppError('', error, { print: false });
    }

    if (error.noError()) {
        log.md(`${commond} ${options[0]}::SUCCESS`)
    } else {
        log.md(`execute [${commond} ${commondName}] result is not 0, confirm is execute success`, `exexute file is [./plugins/${commond}.commong.js]`)
        if (error.isError()) {
            log.men(`execute [${commond} ${commondName}] result is error!`)
        } else {
            log.mwn(`execute [${commond} ${commondName}]  is not complete!`)
        }
    }
    // TODO 后续很如处理 
    // 1. 错误统一处理 深入了解commonder和nodesjs child_process 中的数据回传 eg：process.stdout.write("xxxx") 
    // 将异常传递到父进程
    return error;
}

// commander option 参数转换为 exec 执行的参数
const optionsToArray = (options = {}, except = []) => {
    let res = [];
    for (key in options) {
        if (!except.includes(key)) {
            res.push(`--${key}`);
            res.push(options[key]);
        }
    }
    return res;
}

// 对象绑定执行的参数
const bindArg = (obj, arg) => {
    let newObj = {};
    for (key in obj) {
        newObj[key] = obj[key].bind(null, arg)
    }
    return newObj;
}

// 动态获取环境变量 
const transEnv = (option, fileds = []) => {
    let res = [];
    for (let key in option) {
        if (fileds.includes(key)) {
            res.push(`${camelToConst(key)}=${option[key]}`);
        }
    }
    return res;
}
/**
 * ---
 * ##### 驼峰转下划线
 *  
 * @param {string} camelStr 驼峰字符串 
 * @returns  {string} 下划线字符串
 * @function
 */
const camelToUnderline = camelStr => camelStr.replace(/([A-Z])/g, "_$1").toLowerCase();


/**
 * ---
 * ##### 驼峰转常量格式
 * 
 * @function 
 * @param {string} camelStr 驼峰字符串 
 * @returns  {string} 常量字符串
 * 
 */
const camelToConst = str => camelToUnderline(str).toUpperCase();

/**
 * // TODO 去掉
 * 获取配置文件路径
 * @param {object} param0 
 * @returns  string 路径
 *  文件名称命名规范
 *  commond + name + append+ .config.js
 *  路径 工程跟路径 + 配置相对位置+ 文件
 */
const getConfigPath = (args) => {
    let { opt, append } = args;
    let { commond, options } = opt;
    let fileName = [commond, options[0]].concat(append || []).concat(['config.js']).join('.');
    return resolve(getRootPath(), './static/config', fileName);
}

// 获取静态资源路径下的
const getStaticPath = (path = "") => resolve(getRootPath(), './static/', path)

// 动态加载发布目录 或者当前工程目录的文件
const autoRequireFile = (path, isRoot = true) => autoRequire(isRoot ? resolve(getRootPath(), path) : resolve(path))

// 动态 加载发布目录下的静态文件
const autoRequireStaticFile = (path) => autoRequireFile(getStaticPath(path));

module.exports = {
    praseOpt,
    action,
    optionsToArray,
    bindArg,
    prase,
    transEnv,
    getConfigPath,// TODO 去掉
    getStaticPath,
    autoRequireFile,
    autoRequireStaticFile
}